// Public marketing: set REACT_APP_SHOW_PLAN_INFO=true to show pricing/plan sections and /pricing route
export const SHOW_PLAN_INFO = process.env.REACT_APP_SHOW_PLAN_INFO === 'true';

// API Constants
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
export const SALESPINCH_API_URL = process.env.REACT_APP_SALESPINCH_API_URL || 'https://api.salespinch.com/api';

/** Base URL for public privacy endpoints (/privacy/request, /privacy/verify). Override with REACT_APP_API_URL. */
export const PRIVACY_API_BASE_URL =
  process.env.REACT_APP_API_URL || process.env.REACT_APP_SALESPINCH_API_URL || SALESPINCH_API_URL;

// API Endpoints
export const API_ENDPOINTS = {
  HEALTH: '/',
  CLIENTS: {
    REGISTER: '/api/clients/register',
    GET_BY_ID: '/api/clients',
    DASHBOARD: '/api/clients',
    VALIDATE_API_KEY: '/api/clients/validate-api-key'
  },
  SUBSCRIPTIONS: {
    PLANS: '/api/subscriptions/plans',
    ASSIGN: '/api/subscriptions/assign',
    CLIENT_SUBSCRIPTION: '/api/subscriptions/client',
    VALIDATE_USER_LIMIT: '/api/subscriptions/validate-user-limit',
    VALIDATE_TOKEN_LIMIT: '/api/subscriptions/validate-token-limit'
  },
  PAYMENTS: {
    CREATE_CHECKOUT: '/api/payments/create-checkout-session',
    CREATE_STRIPE_SESSION: '/api/payments/create-stripe-session',
    CREATE_RAZORPAY_ORDER: '/api/payments/create-razorpay-order',
    CONFIRM_STRIPE_PAYMENT: '/api/payments/confirm-stripe-payment',
    VERIFY_RAZORPAY_PAYMENT: '/api/payments/verify-razorpay-payment',
    CHECKOUT_STATUS: '/api/payments/checkout-status',
    HISTORY: '/api/payments/history'
  },
  AI: {
    PROXY: '/api/ai/proxy',
    USAGE: '/api/ai/usage',
    MODELS: '/api/ai/models'
  },
  CONTENT: {
    SECTIONS: '/api/content/sections',
    SECTION: '/api/content/section',
    CREATE: '/api/content',
    UPDATE: '/api/content',
    DELETE: '/api/content',
    INITIALIZE: '/api/content/initialize'
  },
  PRIVACY: {
    REQUEST: '/privacy/request',
    VERIFY: '/privacy/verify'
  }
};

// Subscription Plans
export const PLAN_TYPES = {
  FREE: 1,
  STARTER: 2,
  PROFESSIONAL: 3,
  ENTERPRISE: 4
};

// Status Constants
export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error'
};

// Payment Status
export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PAID: 'paid',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
};

// Subscription Status
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
  CANCELLED: 'Cancelled'
}; 